module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login",
    class: _vm.$style.root
  }, [_c('div', {
    staticClass: "loginform col-lg-6 offset-lg-6 col-md-10"
  }, [_c('div', {
    staticClass: "welcome"
  }, [_vm._v(_vm._s(_vm.$t('pos.login.welcome')))]), _c('p', {
    staticClass: "secondary-txt"
  }, [_vm._v(_vm._s(_vm.$t('pos.login.welcome-secondary')))]), (_vm.token) ? _c('token', {
    on: {
      "login-success": _vm.onLogin
    }
  }) : _vm._e(), (_vm.showEmailLogin) ? _c('email', {
    staticClass: "py-2",
    on: {
      "login-success": _vm.onLogin
    }
  }) : _vm._e(), (_vm.showSSOLogin) ? _c('sso', {
    staticClass: "py-2",
    on: {
      "login-success": _vm.onLogin
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cb8865fe"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/gotu-vue-common/src/components/login/Login.vue
// module id = 2093
// module chunks = 1